var _defs, _path, _g, _g2, _text, _path2, _path3, _g3, _g4, _g5, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDatapilotSlider3 = function SvgDatapilotSlider3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 938 489"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "datapilot_slider3_svg__c",
    x1: 1,
    x2: 0,
    y1: 0.406,
    y2: 0.444,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f15b5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ed901d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "datapilot_slider3_svg__a",
    x1: 0.039,
    x2: 1.039,
    y1: 0.502,
    y2: 0.502,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff603c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e8a50f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#datapilot_slider3_svg__a",
    id: "datapilot_slider3_svg__d",
    x1: 0,
    x2: 1,
    y1: 0.5,
    y2: 0.5
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#datapilot_slider3_svg__a",
    id: "datapilot_slider3_svg__e",
    x1: 0.012,
    x2: 1.01,
    y1: 0.394,
    y2: 0.394
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#datapilot_slider3_svg__a",
    id: "datapilot_slider3_svg__f",
    x1: -4.606,
    x2: -3.447,
    y1: 1.434,
    y2: 1.434
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#datapilot_slider3_svg__a",
    id: "datapilot_slider3_svg__g",
    x1: -0.722,
    x2: 0.304,
    y1: 0.901,
    y2: 0.901
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#datapilot_slider3_svg__a",
    id: "datapilot_slider3_svg__h",
    x1: -1.321,
    x2: -0.252,
    y1: 0.802,
    y2: 0.802
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#datapilot_slider3_svg__a",
    id: "datapilot_slider3_svg__i",
    x1: -0.309,
    x2: 0.725,
    y1: 0.637,
    y2: 0.637
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#datapilot_slider3_svg__a",
    id: "datapilot_slider3_svg__j",
    x1: -1.682,
    x2: -0.682,
    y1: 1.243,
    y2: 1.243
  }), /*#__PURE__*/React.createElement("filter", {
    id: "datapilot_slider3_svg__b",
    width: 938,
    height: 375,
    x: 0,
    y: 114,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fcfcfc",
    d: "M9 64h920v415H9Z",
    "data-name": "Path 52746"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 11"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#datapilot_slider3_svg__b)",
    transform: "translate(.003 -.004)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 920,
    height: 357,
    fill: "#fcfcfc",
    "data-name": "Rectangle 138",
    rx: 10,
    transform: "translate(9 123)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 395"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 967"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 964"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 965"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#707070",
    "data-name": 10,
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 13,
    transform: "translate(104.624 457)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "10")), /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M134.427 448.201a.8.8 0 0 0-.567 1.37l5.814 5.814a.82.82 0 0 0 .567.235.8.8 0 0 0 .567-.235l5.806-5.807a.8.8 0 1 0-1.116-1.143l-5.246 5.266-5.257-5.257a.8.8 0 0 0-.567-.235Z",
    "data-name": "Path 2004"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 966"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#707070",
    "data-name": "1 -10 of 20",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 13,
    transform: "translate(738 457)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1 -10 of 20")), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1915",
    opacity: 0.612
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#666",
    "data-name": "Rectangle 851",
    transform: "translate(875 432)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 36,
    stroke: "none",
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 35,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 9.5
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "m896.607 449.998-4.16-3.781a.667.667 0 0 1 0-1.009.846.846 0 0 1 1.113 0l4.713 4.284a.67.67 0 0 1 .023.985l-4.73 4.314a.85.85 0 0 1-1.113 0 .667.667 0 0 1 0-1.009Z",
    "data-name": "Icon ionic-ios-arrow-back"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1916"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#e1e1e1",
    "data-name": "Rectangle 851",
    transform: "translate(820 432)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 36,
    stroke: "none",
    rx: 10
  }), /*#__PURE__*/React.createElement("rect", {
    width: 39,
    height: 35,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 9.5
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#e1e1e1",
    d: "m838.393 449.998 4.155-3.78a.667.667 0 0 0 0-1.009.846.846 0 0 0-1.113 0l-4.713 4.284a.67.67 0 0 0-.023.985l4.732 4.314a.85.85 0 0 0 1.113 0 .667.667 0 0 0 0-1.009Z",
    "data-name": "Icon ionic-ios-arrow-back"
  }))), /*#__PURE__*/React.createElement("text", {
    "data-name": "Show Row",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 13,
    transform: "translate(23.999 457)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Show Row")))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 58459"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1930"
  }, /*#__PURE__*/React.createElement("text", {
    "data-name": "Questions List",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 20,
    fontWeight: 500,
    transform: "translate(23 172)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Questions List"))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1931",
    transform: "translate(764 143)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 151,
    height: 44,
    fill: "url(#datapilot_slider3_svg__c)",
    "data-name": "Rectangle 24",
    rx: 6
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1974"
  }, /*#__PURE__*/React.createElement("text", {
    fill: "#fff",
    "data-name": "Edit Project",
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 17,
    fontWeight: 500,
    transform: "translate(40.853 28)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Edit Project")), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#fff",
    d: "M31.14 14.772a2.644 2.644 0 0 0-3.736 0L16.999 25.179a.4.4 0 0 0-.1.185l-.888 4.094a.375.375 0 0 0 .446.446l4.094-.888a.4.4 0 0 0 .185-.1L31.14 18.508a2.645 2.645 0 0 0 0-3.736ZM20.281 28.307l-3.418.742.742-3.418 8.97-8.969 2.676 2.676ZM30.61 17.978l-.83.83-2.676-2.676.83-.83a1.892 1.892 0 1 1 2.676 2.676Z",
    "data-name": "Path 2199"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#e6e6e6",
    "data-name": "Rectangle 23",
    transform: "translate(458.927 143)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 294,
    height: 44,
    stroke: "none",
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    width: 293,
    height: 43,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 3.5
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#707070",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "m490.927 175-5.194-5.2m2.879-6.954a9.842 9.842 0 1 1-9.843-9.846 9.84 9.84 0 0 1 9.842 9.842Z",
    "data-name": "Icon akar-search"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e8e8e8",
    d: "M500.927 147v34",
    "data-name": "Line 9"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1929"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#e8e8e8",
    "data-name": "Rectangle 11",
    transform: "translate(22.999 215)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 487,
    height: 53,
    stroke: "none",
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 486,
    height: 52,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 4.5
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "How are interested are you in the National FootballLeague? Please choose one.",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(71.999 235)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "How are interested are you in the National Football"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 20
  }, "League? Please choose one.")), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.894 252.998a59 59 0 0 1-5.962-.316 8.46 8.46 0 0 1-5.746-3.575 1.62 1.62 0 0 0-1.532-.85c-2.023.037-4.049.016-6.072.016-.234 0-.466-.009-.7 0-.516.022-1.016-.146-1.085-.66a1.75 1.75 0 0 1 .435-1.085 10 10 0 0 1 .944-.859c.807-.822.813-.927.113-1.829a11.5 11.5 0 0 1-2.514-7.335 11.655 11.655 0 0 1 22.857-3.044 3.13 3.13 0 0 0 1.222 1.845 9.706 9.706 0 0 1 2.358 13.092c-.7 1.1-.7 1.147.2 2.037a6.7 6.7 0 0 1 .863.772c.219.316.481.8.378 1.079a1.3 1.3 0 0 1-.975.611c-1.007.084-2.023.031-3.033.031h-1.748v.07Zm2.629-1.811a2.854 2.854 0 0 1 .131-3.823 7.02 7.02 0 0 0 1.248-4.966 7.88 7.88 0 0 0-2.7-5.286c-.922 6.629-4.665 10.3-11.252 11.246a6.5 6.5 0 0 0 4.211 2.477c2.692.254 5.412.245 8.366.357Z",
    "data-name": "Path 27"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37.817 239.783c.025-.2.05-.4.079-.588s.058-.385.079-.581a1.8 1.8 0 0 1 .231-.619.4.4 0 0 1 .346-.206.5.5 0 0 1 .151.021.2.2 0 0 1 .1.091l.018.035q-.017.052-.04.129a2 2 0 0 0-.047.189 2 2 0 0 1 .054.318q.017.2.018.472a1 1 0 0 0 .04.182c.025.087.061.2.1.325q.211.6.335.948a4 4 0 0 0 .169.434 1.8 1.8 0 0 0 .516.623 1.08 1.08 0 0 0 .624.2 1.5 1.5 0 0 0 .3-.021q.099-.022.1-.091a14.4 14.4 0 0 1-1.5-2.365 4.2 4.2 0 0 1-.49-1.764c.007-.2.007-.378.007-.549a1 1 0 0 0-.036-.234 1 1 0 0 1-.036-.22c.029-.3.065-.584.1-.84a5.1 5.1 0 0 1 .674-1.833 6.2 6.2 0 0 1 1.406-1.592q.38-.318.7-.542a4 4 0 0 1 .552-.336 4 4 0 0 1 .714-.276 3 3 0 0 1 .739-.094 3.15 3.15 0 0 1 1.262.238 2.6 2.6 0 0 1 .952.707 3 3 0 0 1 .563 1 4 4 0 0 1 .18 1.263c0 .108 0 .231-.014.371s-.022.29-.04.455c-.025.224-.04.4-.054.535a3 3 0 0 1-.036.287 3 3 0 0 1-.054.378 5 5 0 0 1-.123.455q-.088.283-.144.493a1.6 1.6 0 0 0-.065.332 1 1 0 0 1-.076.241 3 3 0 0 1-.18.353l-.177.3-.177.3c-.058.1-.115.245-.2.4s-.195.339-.325.532c-.187.224-.418.5-.689.847s-.591.735-.963 1.183q-.017.078.1.2a2.7 2.7 0 0 0 .346.3c.04.035.1.087.162.154a3 3 0 0 1 .216.248 2 2 0 0 0 .407.385 5 5 0 0 0 .656.4 4 4 0 0 0 .3.252q.186.14.425.322a2.3 2.3 0 0 1 .382.287q.124.125.123.192l-.007.084a1 1 0 0 0-.267.227 1 1 0 0 1-.433.259q-.08.002-.2-.007a1.7 1.7 0 0 1-.278-.053 1.5 1.5 0 0 0-.526-.245.73.73 0 0 1-.35-.15 3 3 0 0 1-.31-.171q-.178-.111-.415-.266a26 26 0 0 1-1.582-1.332 1.2 1.2 0 0 0-.292-.2q-.071 0-.256.192a3.3 3.3 0 0 1-1.486.3 3 3 0 0 0-.346-.1 5 5 0 0 0-.469-.094c-.054-.045-.112-.1-.173-.154a3 3 0 0 0-.227-.182 1 1 0 0 1-.13-.073c-.047-.031-.1-.073-.18-.126a1.13 1.13 0 0 1-.451-.581 6.2 6.2 0 0 1-.353-1.165q-.034-.198-.072-.413a.6.6 0 0 1 .036-.168l.054-.157-.036-.087Zm5.4-7.11a2.4 2.4 0 0 0-1.078.245 3.1 3.1 0 0 0-.948.742 3.6 3.6 0 0 0-.656.983 2.7 2.7 0 0 0-.22 1.078 7 7 0 0 0 .058.913 4.2 4.2 0 0 0 .18.787q.232.662.339 1.015c.107.353.115.371.13.413a1.3 1.3 0 0 0 .169.182q.362.556.736 1.081a6 6 0 0 0 .49.658q.199.22.306.22a1.06 1.06 0 0 0 .7-.441 8 8 0 0 0 .891-1.326c.3-.542.537-1.022.714-1.431a4.1 4.1 0 0 0 .314-1.036q.096-.714.188-1.47c-.029-.1-.058-.2-.09-.283a1.2 1.2 0 0 1-.043-.206 4 4 0 0 0-.054-.29 2.43 2.43 0 0 0-.725-1.372 2.04 2.04 0 0 0-1.388-.458Z",
    "data-name": "Path 28"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M487.052 237a.92.92 0 0 0-.656.276.96.96 0 0 0 0 1.334l6.716 6.833a.94.94 0 0 0 .656.276.9.9 0 0 0 .656-.276l6.707-6.824a.956.956 0 0 0 .022-1.343.92.92 0 0 0-1.311 0l-6.062 6.178-6.073-6.178a.92.92 0 0 0-.656-.276Z",
    "data-name": "Path 2191"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2692"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(566.999 247)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Terminate")), /*#__PURE__*/React.createElement("g", {
    "data-name": "radio"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2690"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c4c4c4",
    d: "M547.499 251a9.5 9.5 0 1 1 9.5-9.5 9.51 9.51 0 0 1-9.5 9.5m0-18.233a8.733 8.733 0 1 0 8.733 8.733 8.743 8.743 0 0 0-8.733-8.733",
    "data-name": "Path 4126"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2693"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(699.999 247)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Quotafull")), /*#__PURE__*/React.createElement("g", {
    "data-name": "radio"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "radio"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2690"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c4c4c4",
    d: "M680.499 251a9.5 9.5 0 1 1 9.5-9.5 9.51 9.51 0 0 1-9.5 9.5m0-18.233a8.733 8.733 0 1 0 8.733 8.733 8.743 8.743 0 0 0-8.733-8.733",
    "data-name": "Path 4126"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(670.999 232)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2690"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M9.5 19A9.5 9.5 0 1 1 19 9.5 9.51 9.51 0 0 1 9.5 19M9.5.767A8.733 8.733 0 1 0 18.233 9.5 8.743 8.743 0 0 0 9.5.767",
    "data-name": "Path 4126"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 6.422,
    cy: 6.422,
    r: 6.422,
    fill: "#f05a5c",
    "data-name": "Ellipse 16",
    transform: "translate(3.078 3.078)"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2694"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(822.999 247)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Completes")), /*#__PURE__*/React.createElement("g", {
    "data-name": "radio"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2690"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c4c4c4",
    d: "M803.499 251a9.5 9.5 0 1 1 9.5-9.5 9.51 9.51 0 0 1-9.5 9.5m0-18.233a8.733 8.733 0 1 0 8.733 8.733 8.743 8.743 0 0 0-8.733-8.733",
    "data-name": "Path 4126"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "raw"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "raw1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1929"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#e8e8e8",
    "data-name": "Rectangle 11",
    transform: "translate(22.999 289)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 487,
    height: 53,
    stroke: "none",
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 486,
    height: 52,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 4.5
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "How are interested are you in the National FootballLeague? Please choose one.",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(71.999 309)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "How are interested are you in the National Football"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 20
  }, "League? Please choose one.")), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.894 326.998a59 59 0 0 1-5.962-.316 8.46 8.46 0 0 1-5.746-3.575 1.62 1.62 0 0 0-1.532-.85c-2.023.037-4.049.016-6.072.016-.234 0-.466-.009-.7 0-.516.022-1.016-.146-1.085-.66a1.75 1.75 0 0 1 .435-1.085 10 10 0 0 1 .944-.859c.807-.822.813-.927.113-1.829a11.5 11.5 0 0 1-2.514-7.335 11.655 11.655 0 0 1 22.857-3.044 3.13 3.13 0 0 0 1.222 1.845 9.706 9.706 0 0 1 2.358 13.092c-.7 1.1-.7 1.147.2 2.037a6.7 6.7 0 0 1 .863.772c.219.316.481.8.378 1.079a1.3 1.3 0 0 1-.975.611c-1.007.084-2.023.031-3.033.031h-1.748v.07Zm2.629-1.811a2.854 2.854 0 0 1 .131-3.823 7.02 7.02 0 0 0 1.248-4.966 7.88 7.88 0 0 0-2.7-5.286c-.922 6.629-4.665 10.3-11.252 11.246a6.5 6.5 0 0 0 4.211 2.477c2.692.254 5.412.245 8.366.357Z",
    "data-name": "Path 27"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37.817 313.783c.025-.2.05-.4.079-.588s.058-.385.079-.581a1.8 1.8 0 0 1 .231-.619.4.4 0 0 1 .346-.206.5.5 0 0 1 .151.021.2.2 0 0 1 .1.091l.018.035q-.017.052-.04.129a2 2 0 0 0-.047.189 2 2 0 0 1 .054.318q.017.2.018.472a1 1 0 0 0 .04.182c.025.087.061.2.1.325q.211.6.335.948a4 4 0 0 0 .169.434 1.8 1.8 0 0 0 .516.623 1.08 1.08 0 0 0 .624.2 1.5 1.5 0 0 0 .3-.021q.099-.022.1-.091a14.4 14.4 0 0 1-1.5-2.365 4.2 4.2 0 0 1-.49-1.764c.007-.2.007-.378.007-.549a1 1 0 0 0-.036-.234 1 1 0 0 1-.036-.22c.029-.3.065-.584.1-.84a5.1 5.1 0 0 1 .674-1.833 6.2 6.2 0 0 1 1.406-1.592q.38-.318.7-.542a4 4 0 0 1 .552-.336 4 4 0 0 1 .714-.276 3 3 0 0 1 .739-.094 3.15 3.15 0 0 1 1.262.238 2.6 2.6 0 0 1 .952.707 3 3 0 0 1 .563 1 4 4 0 0 1 .18 1.263c0 .108 0 .231-.014.371s-.022.29-.04.455c-.025.224-.04.4-.054.535a3 3 0 0 1-.036.287 3 3 0 0 1-.054.378 5 5 0 0 1-.123.455q-.088.283-.144.493a1.6 1.6 0 0 0-.065.332 1 1 0 0 1-.076.241 3 3 0 0 1-.18.353l-.177.3-.177.3c-.058.1-.115.245-.2.4s-.195.339-.325.532c-.187.224-.418.5-.689.847s-.591.735-.963 1.183q-.017.078.1.2a2.7 2.7 0 0 0 .346.3c.04.035.1.087.162.154a3 3 0 0 1 .216.248 2 2 0 0 0 .407.385 5 5 0 0 0 .656.4 4 4 0 0 0 .3.252q.186.14.425.322a2.3 2.3 0 0 1 .382.287q.124.125.123.192l-.007.084a1 1 0 0 0-.267.227 1 1 0 0 1-.433.259q-.08.002-.2-.007a1.7 1.7 0 0 1-.278-.053 1.5 1.5 0 0 0-.526-.245.73.73 0 0 1-.35-.15 3 3 0 0 1-.31-.171q-.178-.111-.415-.266a26 26 0 0 1-1.582-1.332 1.2 1.2 0 0 0-.292-.2q-.071 0-.256.192a3.3 3.3 0 0 1-1.486.3 3 3 0 0 0-.346-.1 5 5 0 0 0-.469-.094c-.054-.045-.112-.1-.173-.154a3 3 0 0 0-.227-.182 1 1 0 0 1-.13-.073c-.047-.031-.1-.073-.18-.126a1.13 1.13 0 0 1-.451-.581 6.2 6.2 0 0 1-.353-1.165q-.034-.198-.072-.413a.6.6 0 0 1 .036-.168l.054-.157-.036-.087Zm5.4-7.11a2.4 2.4 0 0 0-1.078.245 3.1 3.1 0 0 0-.948.742 3.6 3.6 0 0 0-.656.983 2.7 2.7 0 0 0-.22 1.078 7 7 0 0 0 .058.913 4.2 4.2 0 0 0 .18.787q.232.662.339 1.015c.107.353.115.371.13.413a1.3 1.3 0 0 0 .169.182q.362.556.736 1.081a6 6 0 0 0 .49.658q.199.22.306.22a1.06 1.06 0 0 0 .7-.441 8 8 0 0 0 .891-1.326c.3-.542.537-1.022.714-1.431a4.1 4.1 0 0 0 .314-1.036q.096-.714.188-1.47c-.029-.1-.058-.2-.09-.283a1.2 1.2 0 0 1-.043-.206 4 4 0 0 0-.054-.29 2.43 2.43 0 0 0-.725-1.372 2.04 2.04 0 0 0-1.388-.458Z",
    "data-name": "Path 28"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "noun-arrow-down-2424963"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M487.052 311a.92.92 0 0 0-.656.276.96.96 0 0 0 0 1.334l6.716 6.833a.94.94 0 0 0 .656.276.9.9 0 0 0 .656-.276l6.707-6.824a.956.956 0 0 0 .022-1.343.92.92 0 0 0-1.311 0l-6.062 6.178-6.073-6.178a.92.92 0 0 0-.656-.276Z",
    "data-name": "Path 2191"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2692"
  }, /*#__PURE__*/React.createElement("text", {
    "data-name": "Terminate",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(566.999 321)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Terminate")), /*#__PURE__*/React.createElement("g", {
    "data-name": "radio"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "radio"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2690"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c4c4c4",
    d: "M547.499 325a9.5 9.5 0 1 1 9.5-9.5 9.51 9.51 0 0 1-9.5 9.5m0-18.233a8.733 8.733 0 1 0 8.733 8.733 8.743 8.743 0 0 0-8.733-8.733",
    "data-name": "Path 4126"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "active",
    transform: "translate(537.999 306)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2690"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M9.5 19A9.5 9.5 0 1 1 19 9.5 9.51 9.51 0 0 1 9.5 19M9.5.767A8.733 8.733 0 1 0 18.233 9.5 8.743 8.743 0 0 0 9.5.767",
    "data-name": "Path 4126"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 6.422,
    cy: 6.422,
    r: 6.422,
    fill: "#f05a5c",
    "data-name": "Ellipse 16",
    transform: "translate(3.078 3.078)"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2693"
  }, /*#__PURE__*/React.createElement("text", {
    "data-name": "Quotafull",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(699.999 321)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Quotafull")), /*#__PURE__*/React.createElement("g", {
    "data-name": "radio"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2690"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c4c4c4",
    d: "M680.499 325a9.5 9.5 0 1 1 9.5-9.5 9.51 9.51 0 0 1-9.5 9.5m0-18.233a8.733 8.733 0 1 0 8.733 8.733 8.743 8.743 0 0 0-8.733-8.733",
    "data-name": "Path 4126"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2694"
  }, /*#__PURE__*/React.createElement("text", {
    "data-name": "Completes",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(822.999 321)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Completes")), /*#__PURE__*/React.createElement("g", {
    "data-name": "radio"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2690"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c4c4c4",
    d: "M803.499 325a9.5 9.5 0 1 1 9.5-9.5 9.51 9.51 0 0 1-9.5 9.5m0-18.233a8.733 8.733 0 1 0 8.733 8.733 8.743 8.743 0 0 0-8.733-8.733",
    "data-name": "Path 4126"
  }))))), /*#__PURE__*/React.createElement("g", {
    "data-name": "raw"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "raw1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1929"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#e8e8e8",
    "data-name": "Rectangle 11",
    transform: "translate(22.999 363)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 487,
    height: 53,
    stroke: "none",
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 486,
    height: 52,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 4.5
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": "How are interested are you in the National FootballLeague? Please choose one.",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(71.999 383)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "How are interested are you in the National Football"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 20
  }, "League? Please choose one.")), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.894 400.998a59 59 0 0 1-5.962-.316 8.46 8.46 0 0 1-5.746-3.575 1.62 1.62 0 0 0-1.532-.85c-2.023.037-4.049.016-6.072.016-.234 0-.466-.009-.7 0-.516.022-1.016-.146-1.085-.66a1.75 1.75 0 0 1 .435-1.085 10 10 0 0 1 .944-.859c.807-.822.813-.927.113-1.829a11.5 11.5 0 0 1-2.514-7.335 11.655 11.655 0 0 1 22.857-3.044 3.13 3.13 0 0 0 1.222 1.845 9.706 9.706 0 0 1 2.358 13.092c-.7 1.1-.7 1.147.2 2.037a6.7 6.7 0 0 1 .863.772c.219.316.481.8.378 1.079a1.3 1.3 0 0 1-.975.611c-1.007.084-2.023.031-3.033.031h-1.748v.07Zm2.629-1.811a2.854 2.854 0 0 1 .131-3.823 7.02 7.02 0 0 0 1.248-4.966 7.88 7.88 0 0 0-2.7-5.286c-.922 6.629-4.665 10.3-11.252 11.246a6.5 6.5 0 0 0 4.211 2.477c2.692.254 5.412.245 8.366.357Z",
    "data-name": "Path 27"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M37.817 387.783c.025-.2.05-.4.079-.588s.058-.385.079-.581a1.8 1.8 0 0 1 .231-.619.4.4 0 0 1 .346-.206.5.5 0 0 1 .151.021.2.2 0 0 1 .1.091l.018.035q-.017.052-.04.129a2 2 0 0 0-.047.189 2 2 0 0 1 .054.318q.017.2.018.472a1 1 0 0 0 .04.182c.025.087.061.2.1.325q.211.6.335.948a4 4 0 0 0 .169.434 1.8 1.8 0 0 0 .516.623 1.08 1.08 0 0 0 .624.2 1.5 1.5 0 0 0 .3-.021q.099-.022.1-.091a14.4 14.4 0 0 1-1.5-2.365 4.2 4.2 0 0 1-.49-1.764c.007-.2.007-.378.007-.549a1 1 0 0 0-.036-.234 1 1 0 0 1-.036-.22c.029-.3.065-.584.1-.84a5.1 5.1 0 0 1 .674-1.833 6.2 6.2 0 0 1 1.406-1.592q.38-.318.7-.542a4 4 0 0 1 .552-.336 4 4 0 0 1 .714-.276 3 3 0 0 1 .739-.094 3.15 3.15 0 0 1 1.262.238 2.6 2.6 0 0 1 .952.707 3 3 0 0 1 .563 1 4 4 0 0 1 .18 1.263c0 .108 0 .231-.014.371s-.022.29-.04.455c-.025.224-.04.4-.054.535a3 3 0 0 1-.036.287 3 3 0 0 1-.054.378 5 5 0 0 1-.123.455q-.088.283-.144.493a1.6 1.6 0 0 0-.065.332 1 1 0 0 1-.076.241 3 3 0 0 1-.18.353l-.177.3-.177.3c-.058.1-.115.245-.2.4s-.195.339-.325.532c-.187.224-.418.5-.689.847s-.591.735-.963 1.183q-.017.078.1.2a2.7 2.7 0 0 0 .346.3c.04.035.1.087.162.154a3 3 0 0 1 .216.248 2 2 0 0 0 .407.385 5 5 0 0 0 .656.4 4 4 0 0 0 .3.252q.186.14.425.322a2.3 2.3 0 0 1 .382.287q.124.125.123.192l-.007.084a1 1 0 0 0-.267.227 1 1 0 0 1-.433.259q-.08.002-.2-.007a1.7 1.7 0 0 1-.278-.053 1.5 1.5 0 0 0-.526-.245.73.73 0 0 1-.35-.15 3 3 0 0 1-.31-.171q-.178-.111-.415-.266a26 26 0 0 1-1.582-1.332 1.2 1.2 0 0 0-.292-.2q-.071 0-.256.192a3.3 3.3 0 0 1-1.486.3 3 3 0 0 0-.346-.1 5 5 0 0 0-.469-.094c-.054-.045-.112-.1-.173-.154a3 3 0 0 0-.227-.182 1 1 0 0 1-.13-.073c-.047-.031-.1-.073-.18-.126a1.13 1.13 0 0 1-.451-.581 6.2 6.2 0 0 1-.353-1.165q-.034-.198-.072-.413a.6.6 0 0 1 .036-.168l.054-.157-.036-.087Zm5.4-7.11a2.4 2.4 0 0 0-1.078.245 3.1 3.1 0 0 0-.948.742 3.6 3.6 0 0 0-.656.983 2.7 2.7 0 0 0-.22 1.078 7 7 0 0 0 .058.913 4.2 4.2 0 0 0 .18.787q.232.662.339 1.015c.107.353.115.371.13.413a1.3 1.3 0 0 0 .169.182q.362.556.736 1.081a6 6 0 0 0 .49.658q.199.22.306.22a1.06 1.06 0 0 0 .7-.441 8 8 0 0 0 .891-1.326c.3-.542.537-1.022.714-1.431a4.1 4.1 0 0 0 .314-1.036q.096-.714.188-1.47c-.029-.1-.058-.2-.09-.283a1.2 1.2 0 0 1-.043-.206 4 4 0 0 0-.054-.29 2.43 2.43 0 0 0-.725-1.372 2.04 2.04 0 0 0-1.388-.458Z",
    "data-name": "Path 28"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "noun-arrow-down-2424963"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M487.052 385a.92.92 0 0 0-.656.276.96.96 0 0 0 0 1.334l6.716 6.833a.94.94 0 0 0 .656.276.9.9 0 0 0 .656-.276l6.707-6.824a.956.956 0 0 0 .022-1.343.92.92 0 0 0-1.311 0l-6.062 6.178-6.073-6.178a.92.92 0 0 0-.656-.276Z",
    "data-name": "Path 2191"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2692"
  }, /*#__PURE__*/React.createElement("text", {
    "data-name": "Terminate",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(566.999 395)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Terminate")), /*#__PURE__*/React.createElement("g", {
    "data-name": "radio"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "radio"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2690"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c4c4c4",
    d: "M547.499 399a9.5 9.5 0 1 1 9.5-9.5 9.51 9.51 0 0 1-9.5 9.5m0-18.233a8.733 8.733 0 1 0 8.733 8.733 8.743 8.743 0 0 0-8.733-8.733",
    "data-name": "Path 4126"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "active",
    transform: "translate(537.999 380)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2690"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f05a5c",
    d: "M9.5 19A9.5 9.5 0 1 1 19 9.5 9.51 9.51 0 0 1 9.5 19M9.5.767A8.733 8.733 0 1 0 18.233 9.5 8.743 8.743 0 0 0 9.5.767",
    "data-name": "Path 4126"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 6.422,
    cy: 6.422,
    r: 6.422,
    fill: "#f05a5c",
    "data-name": "Ellipse 16",
    transform: "translate(3.078 3.078)"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2693"
  }, /*#__PURE__*/React.createElement("text", {
    "data-name": "Quotafull",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(699.999 395)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Quotafull")), /*#__PURE__*/React.createElement("g", {
    "data-name": "radio"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2690"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c4c4c4",
    d: "M680.499 399a9.5 9.5 0 1 1 9.5-9.5 9.51 9.51 0 0 1-9.5 9.5m0-18.233a8.733 8.733 0 1 0 8.733 8.733 8.743 8.743 0 0 0-8.733-8.733",
    "data-name": "Path 4126"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2694"
  }, /*#__PURE__*/React.createElement("text", {
    "data-name": "Completes",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(822.999 395)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Completes")), /*#__PURE__*/React.createElement("g", {
    "data-name": "radio"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2690"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c4c4c4",
    d: "M803.499 399a9.5 9.5 0 1 1 9.5-9.5 9.51 9.51 0 0 1-9.5 9.5m0-18.233a8.733 8.733 0 1 0 8.733 8.733 8.743 8.743 0 0 0-8.733-8.733",
    "data-name": "Path 4126"
  }))))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 396",
    transform: "translate(-16 -47)"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 22,
    fontWeight: 500,
    transform: "translate(25 143)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Projects")), /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 3,
    fill: "#f05a5c",
    "data-name": "Rectangle 141",
    rx: 1.5,
    transform: "translate(26 153)"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    fill: "#656565",
    "data-name": "Project_name_3452_user-survey / Question List",
    fontFamily: "Poppins-Light, Poppins",
    fontSize: 15,
    fontWeight: 300,
    transform: "translate(562 97)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Project_name_3452_user-survey"), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fontFamily: "SegoeUI, Segoe UI",
    fontWeight: 400
  }), /*#__PURE__*/React.createElement("tspan", {
    xmlSpace: "preserve",
    y: 0,
    fill: "#505050",
    fontFamily: "SegoeUI, Segoe UI",
    fontWeight: 400
  }, " /  "), /*#__PURE__*/React.createElement("tspan", {
    y: 0,
    fill: "#000",
    fontFamily: "Poppins-Medium, Poppins",
    fontWeight: 500
  }, "Question List"))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcfcfc",
    d: "M9 0h920v64H9z",
    "data-name": "Rectangle 4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e8e8e8",
    d: "M9 64h920",
    "data-name": "Line 1"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 373"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 4 \\u2013 34",
    transform: "translate(307 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 165,
    height: 40,
    fill: "#f9f9f9",
    "data-name": "Rectangle 10",
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1934"
  }, /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(60 26)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Dashboard")), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    "data-name": "Icon material-dashboard"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 21.111h8.889V10H15ZM15 30h8.889v-6.667H15Zm11.111 0H35V18.889h-8.889Zm0-20v6.667H35V10Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M33 28v-7.111h-4.889V28zm-11.111 0v-2.667H17V28zm0-8.889V12H17v7.111zM33 14.667V12h-4.889v2.667zM35 30h-8.889V18.889H35zm-11.111 0H15v-6.667h8.889zm0-8.889H15V10h8.889zM35 16.667h-8.889V10H35z"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 4 \\u2013 35",
    transform: "translate(490 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 165,
    height: 40,
    fill: "#f2f2f2",
    "data-name": "Rectangle 10",
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1935"
  }, /*#__PURE__*/React.createElement("text", {
    "data-name": "Projects",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(74 26)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Projects")), /*#__PURE__*/React.createElement("path", {
    d: "M49 27.778A2.21 2.21 0 0 1 46.8 30H29.2a2.21 2.21 0 0 1-2.2-2.222V12.222A2.21 2.21 0 0 1 29.2 10h5.5l2.2 3.333h9.9a2.21 2.21 0 0 1 2.2 2.223Z",
    "data-name": "Icon feather-folder"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#f15b5b",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M136.5 41h-108",
    "data-name": "Line 11"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 4 \\u2013 36",
    transform: "translate(668 4)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 165,
    height: 40,
    fill: "#f9f9f9",
    "data-name": "Rectangle 10",
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1921"
  }, /*#__PURE__*/React.createElement("text", {
    "data-name": "Add Project",
    fontFamily: "Poppins-Regular, Poppins",
    fontSize: 16,
    transform: "translate(59.724 26)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Add Project")), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    "data-name": "Icon feather-folder-plus"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.134 27.778A2.22 2.22 0 0 1 34.921 30H17.213A2.22 2.22 0 0 1 15 27.778V12.222A2.22 2.22 0 0 1 17.213 10h5.534l2.213 3.333h9.96a2.22 2.22 0 0 1 2.213 2.222Z",
    "data-name": "Path 5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.067 18.889v6.667",
    "data-name": "Path 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.747 22.222h6.64",
    "data-name": "Path 7"
  })))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Component 2 \\u2013 11"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2",
    transform: "translate(-838 -19)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 40,
    fill: "#e0e0e0",
    "data-name": "Rectangle 3",
    rx: 5,
    transform: "translate(1719 23)"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Poppins-Medium, Poppins",
    fontSize: 20,
    fontWeight: 500,
    transform: "translate(1743 51)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -14.7,
    y: 0
  }, "AG"))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2661"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2658"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#datapilot_slider3_svg__a)",
    d: "M29.506 13.184A12.886 12.886 0 0 1 17.039 30.17 12.88 12.88 0 0 1 4.413 17.039a12.883 12.883 0 0 1 21-9.744 6.6 6.6 0 0 0 .854.567 20 20 0 0 1 1.351-1.606 17 17 0 0 1 1.461-1.577l-.064-.03.064.03.024-.011a17.293 17.293 0 1 0-18.86 28.422 17.3 17.3 0 0 0 23.1-22.215 23 23 0 0 0-.215-.512l-.03.01",
    "data-name": "Path 3839",
    transform: "rotate(-8 151.24 -679.572)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#datapilot_slider3_svg__d)",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.25,
    d: "M13.52 25.452 0 11.131l11.769 6.494L36.127 0Z",
    "data-name": "Path 3840",
    transform: "rotate(-8 149.46 -703.978)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2659",
    transform: "rotate(-8 81.45 -884.64)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#datapilot_slider3_svg__e)",
    d: "M3.564.128a.567.567 0 1 1 .677.909L.9 3.535a.567.567 0 0 1-.678-.909Z",
    "data-name": "Path 3841",
    transform: "translate(1.017 10.371)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#datapilot_slider3_svg__f)",
    d: "M2.853.216a.567.567 0 1 1 .86.738L.994 4.122a.568.568 0 0 1-.86-.738Z",
    "data-name": "Path 3842",
    transform: "translate(2.958 12.462)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#datapilot_slider3_svg__g)",
    fillRule: "evenodd",
    d: "M3.669 3.636 0 2.932C3.706-.168 3.907-.026 6.612.013a18.6 18.6 0 0 0-2.943 3.625Z",
    "data-name": "Path 3843",
    transform: "translate(0 5.463)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#datapilot_slider3_svg__h)",
    fillRule: "evenodd",
    d: "m0 2.355.1 3.689C3.727 2.853 3.617 2.634 4.031 0A26.6 26.6 0 0 1 0 2.357Z",
    "data-name": "Path 3844",
    transform: "translate(8.406 12.269)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#datapilot_slider3_svg__i)",
    fillRule: "evenodd",
    d: "M13.826 6.566c-1.455 2.427-7.259 6.934-10.37 7.793L0 10.329c1.281-2.906 6.7-7.947 9.322-9.015 6.9-2.77 8.3-1.224 4.505 5.253ZM11.573 3.94a2.343 2.343 0 0 1-.3 3.319 2.34 2.34 0 0 1-3.326-.213 2.386 2.386 0 1 1 3.626-3.106",
    "data-name": "Path 3845",
    transform: "translate(3.702)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.372,
    cy: 1.372,
    r: 1.372,
    fill: "url(#datapilot_slider3_svg__j)",
    "data-name": "Ellipse 15",
    transform: "translate(12.092 4.122)"
  })))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.993 41.617q-1.127 0-1.127-1.192V20.261q0-1.192 1.127-1.192h5.508a7.32 7.32 0 0 1 6.249 2.738q2.062 2.738 2.062 8.5 0 5.8-2.062 8.552a7.3 7.3 0 0 1-6.249 2.754Zm3.157-3.608h2.384a3.13 3.13 0 0 0 3.012-1.82 13.9 13.9 0 0 0 .918-5.879 13.65 13.65 0 0 0-.918-5.83 3.13 3.13 0 0 0-3.012-1.8H14.15Zm17.459 3.833a4.39 4.39 0 0 1-3.431-1.341 5.3 5.3 0 0 1-1.208-3.688 5.8 5.8 0 0 1 .805-3.044 5.48 5.48 0 0 1 2.609-2.126 12.2 12.2 0 0 1 4.8-.789v-.87a2.4 2.4 0 0 0-.5-1.594 2.14 2.14 0 0 0-1.723-.6 7.9 7.9 0 0 0-2.094.258 13 13 0 0 0-1.546.515 2.7 2.7 0 0 1-.87.258q-.29 0-.467-.419a4 4 0 0 1-.258-.966 6.4 6.4 0 0 1-.081-.9q0-.419.821-.886a8.5 8.5 0 0 1 2.11-.789 10.9 10.9 0 0 1 2.641-.322q3.189 0 4.638 1.466a5.24 5.24 0 0 1 1.45 3.849v6.474a19 19 0 0 0 .161 2.963 8.4 8.4 0 0 1 .161 1.321.58.58 0 0 1-.37.515 3.6 3.6 0 0 1-.886.306 9 9 0 0 1-1 .161q-.483.048-.709.048a.78.78 0 0 1-.757-.387 5.4 5.4 0 0 1-.4-1.385 5.5 5.5 0 0 1-1.482 1.345 4.35 4.35 0 0 1-2.414.628Zm1.288-3.028a2.35 2.35 0 0 0 1.3-.387 3.1 3.1 0 0 0 .982-1.031v-3.93a5 5 0 0 0-3.173.773 2.86 2.86 0 0 0-.918 2.319 2.7 2.7 0 0 0 .451 1.643 1.57 1.57 0 0 0 1.358.614Zm13.948 3.028a4.08 4.08 0 0 1-2.835-1.015 4.4 4.4 0 0 1-1.127-3.4v-9.406h-.9q-.87 0-.87-1.385v-.483q0-1.385.87-1.385h.9l.483-3.157q.161-.934 1.417-.934h.773q1.45 0 1.45.934v3.157h1.643q.87 0 .87 1.385v.483q0 1.385-.87 1.385h-1.643v8.987a2.6 2.6 0 0 0 .209 1.224.8.8 0 0 0 .757.354 2.5 2.5 0 0 0 .66-.064 1.5 1.5 0 0 1 .435-.064q.258 0 .419.4a4.3 4.3 0 0 1 .242.886 5 5 0 0 1 .081.741.87.87 0 0 1-.451.725 3.4 3.4 0 0 1-1.144.467 6 6 0 0 1-1.369.166Zm9.019 0a4.39 4.39 0 0 1-3.431-1.341 5.3 5.3 0 0 1-1.21-3.683 5.8 5.8 0 0 1 .805-3.044 5.48 5.48 0 0 1 2.609-2.126 12.2 12.2 0 0 1 4.8-.789v-.87a2.4 2.4 0 0 0-.5-1.594 2.14 2.14 0 0 0-1.723-.6 7.9 7.9 0 0 0-2.094.258 13 13 0 0 0-1.546.515 2.7 2.7 0 0 1-.87.258q-.29 0-.467-.419a4 4 0 0 1-.258-.966 6.4 6.4 0 0 1-.081-.9q0-.419.821-.886a8.5 8.5 0 0 1 2.11-.789 10.9 10.9 0 0 1 2.641-.322q3.189 0 4.638 1.466a5.24 5.24 0 0 1 1.45 3.849v6.474a19 19 0 0 0 .165 2.968 8.4 8.4 0 0 1 .161 1.321.58.58 0 0 1-.37.515 3.6 3.6 0 0 1-.886.306 9 9 0 0 1-1 .161q-.483.048-.709.048a.78.78 0 0 1-.757-.387 5.4 5.4 0 0 1-.4-1.385 5.5 5.5 0 0 1-1.482 1.337 4.35 4.35 0 0 1-2.416.626Zm1.288-3.028a2.35 2.35 0 0 0 1.3-.387 3.1 3.1 0 0 0 .982-1.031v-3.93a5 5 0 0 0-3.173.773 2.86 2.86 0 0 0-.918 2.319 2.7 2.7 0 0 0 .451 1.643 1.57 1.57 0 0 0 1.358.614Zm11.725 2.867a2.73 2.73 0 0 1-1.337-.242.76.76 0 0 1-.4-.693V20.261q0-1.192 1.127-1.192h5.283q6.668 0 6.668 6.861 0 6.893-6.668 6.893h-2.127v7.924a.76.76 0 0 1-.4.693 2.73 2.73 0 0 1-1.337.242Zm2.546-12.465h2.126a2.22 2.22 0 0 0 1.917-.773 4.34 4.34 0 0 0 .564-2.512 4.27 4.27 0 0 0-.564-2.48 2.22 2.22 0 0 0-1.917-.773h-2.126Zm12.143 12.466a2.65 2.65 0 0 1-1.3-.242.76.76 0 0 1-.4-.693V25.64a.76.76 0 0 1 .4-.693 2.65 2.65 0 0 1 1.3-.242h.709a2.65 2.65 0 0 1 1.3.242.76.76 0 0 1 .4.693v15.107a.76.76 0 0 1-.4.693 2.65 2.65 0 0 1-1.3.242Zm.386-18.781a3.8 3.8 0 0 1-1.578-.242.75.75 0 0 1-.483-.693v-2.319a.73.73 0 0 1 .483-.66 3.8 3.8 0 0 1 1.578-.242 3.9 3.9 0 0 1 1.546.225.72.72 0 0 1 .483.676v2.319a.75.75 0 0 1-.483.693 3.7 3.7 0 0 1-1.546.243m9.277 18.94a4.08 4.08 0 0 1-2.835-1.015 4.4 4.4 0 0 1-1.127-3.4V18.301a.76.76 0 0 1 .4-.693 2.65 2.65 0 0 1 1.3-.242h.709a2.65 2.65 0 0 1 1.3.242.76.76 0 0 1 .4.693v18.71a2.6 2.6 0 0 0 .209 1.224.8.8 0 0 0 .757.354 2.5 2.5 0 0 0 .66-.064 1.5 1.5 0 0 1 .435-.064q.258 0 .419.4a4.3 4.3 0 0 1 .242.886 5 5 0 0 1 .081.741.87.87 0 0 1-.451.725 3.4 3.4 0 0 1-1.144.467 6 6 0 0 1-1.355.163Zm48.575 0a4.08 4.08 0 0 1-2.835-1.015 4.4 4.4 0 0 1-1.127-3.4V28.02h-.9q-.87 0-.87-1.385v-.483q0-1.385.87-1.385h.9l.483-3.157q.161-.934 1.417-.934h.773q1.45 0 1.45.934v3.157h1.643q.87 0 .87 1.385v.483q0 1.385-.87 1.385h-1.643v8.987a2.6 2.6 0 0 0 .209 1.224.8.8 0 0 0 .757.354 2.5 2.5 0 0 0 .66-.064 1.5 1.5 0 0 1 .435-.064q.258 0 .419.4a4.3 4.3 0 0 1 .242.886 5 5 0 0 1 .081.741.87.87 0 0 1-.451.725 3.4 3.4 0 0 1-1.144.467 6 6 0 0 1-1.369.167Z",
    "data-name": "Path 3846"
  })));
};
export default SvgDatapilotSlider3;